/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';

/**
 * 
 * @export
 * @interface OverridePaymentStateDto
 */
export interface OverridePaymentStateDto {
    /**
     * 
     * @type {PaymentState}
     * @memberof OverridePaymentStateDto
     */
    newState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof OverridePaymentStateDto
     */
    reason: string;
}



/**
 * Check if a given object implements the OverridePaymentStateDto interface.
 */
export function instanceOfOverridePaymentStateDto(value: object): value is OverridePaymentStateDto {
    if (!('newState' in value) || value['newState'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function OverridePaymentStateDtoFromJSON(json: any): OverridePaymentStateDto {
    return OverridePaymentStateDtoFromJSONTyped(json, false);
}

export function OverridePaymentStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverridePaymentStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'newState': PaymentStateFromJSON(json['newState']),
        'reason': json['reason'],
    };
}

export function OverridePaymentStateDtoToJSON(json: any): OverridePaymentStateDto {
    return OverridePaymentStateDtoToJSONTyped(json, false);
}

export function OverridePaymentStateDtoToJSONTyped(value?: OverridePaymentStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newState': PaymentStateToJSON(value['newState']),
        'reason': value['reason'],
    };
}

